var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.position
    ? _c("div", { class: `cf-spinner-${_vm.position}` }, [
        _c(
          "div",
          {
            staticClass: "fa fa-spinner fa-spin cf-spinner",
            class: _vm.classes,
            style: _vm.style,
          },
          [_vm._v("​")]
        ),
      ])
    : _c(
        "div",
        {
          staticClass: "fa fa-spinner fa-spin cf-spinner",
          class: _vm.classes,
          style: _vm.style,
        },
        [_vm._v("​")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }